import type { UserProperties } from "@/APIClient";
import type { Diagnostic } from "./diagnostics.types";

export enum FileType {
  DIAGNOSTIC_REPORT = "DIAGNOSTIC_REPORT",
  DIAGNOSTIC_IMAGE = "DIAGNOSTIC_IMAGE",
  PROJECT_IMAGE = "PROJECT_IMAGE",
  REPORT_TEMPLATE = "REPORT_TEMPLATE",
  DRAWING_IMAGE = "DRAWING_IMAGE",
  OBSERVATION_AUDIO = "OBSERVATION_AUDIO",
  REVISION_DWG = "REVISION_DWG",
  LEGEND_DWG = "LEGEND_DWG",
}
export interface FileEntity {
  id: number;
  createdAt: string;
  updatedAt: string;
  enabled: boolean;
  path: string;
  originalName: string;
  mimeType: string;
  size: number;
  fileType: FileType;
  ownerId?: number;
  owner?: UserProperties;
  diagnosticId?: number;
  diagnostic?: Diagnostic;
}

export type FileParams = {
  diagnosticId?: number;
  projectId?: number;
  drawingId?: number;
  legendId?: number;
};

export type FinalizeUploadResponse = {
  id: number;
  path: string;
  originalName: string;
  mimeType: string;
  size: number;
  status: string;
  fileType: FileType;
  ownerId: number;
  createdAt: string;
  updatedAt: string;
  diagnosticImageId?: number;
};
